import { render, staticRenderFns } from "./DynamicAttributeSourceResource.vue?vue&type=template&id=206a00ee&"
import script from "./DynamicAttributeSourceResource.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeSourceResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports